import React, { useEffect} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Update_Password } from "../../ReduxStore/Slice/Auth/AuthSlice";
import axios from "axios";
import toast from "react-hot-toast";
import ToastButton from "../../Components/ExtraComponents/Alert_Toast";
import Formikform from "../../Components/ExtraComponents/Form/Formik_form";
import { useFormik } from "formik";
import * as valid_err from "../../Utils/Common_Messages";
import { Email_regex } from "../../Utils/Common_regex";
import { decode } from "js-base64";

const UpdatePassword = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dcoded_UsrId = decode(id).replace(/"/g, "");
  const dispatch = useDispatch();

  const GetAllThemes = () => {
    axios
      .get("https://api.smartalgo.in:3001/smartalgo/get/theme")
      .then(() => {})
      .catch(() => {});
  };

  useEffect(() => {
    GetAllThemes();
  }, []);

  const isValidEmail = (email) => Email_regex(email);

  const formik = useFormik({
    initialValues: { newpassword: "", confirmpassword: "" },
    validate: (values) => {
      const errors = {};
      if (!values.newpassword) errors.newpassword = valid_err.NEW_PASSWORD_ERROR;
      if (!values.confirmpassword) {
        errors.confirmpassword = valid_err.CONFIRM_PASSWORD_ERROR;
      } else if (values.newpassword !== values.confirmpassword) {
        errors.confirmpassword = valid_err.CONFIRM_AND_NEW_PASSWORD_ERROR;
      }
      return errors;
    },
    onSubmit: async (values) => {
      const req = {
        newpassword: values.newpassword,
        confirmpassword: values.confirmpassword,
        userid: dcoded_UsrId,
      };
      await dispatch(Update_Password(req))
        .unwrap()
        .then((response) => {
          if (response.status) {
            toast.success(response.msg);
            setTimeout(() => navigate("/login", { replace: true }), 2000);
          } else if (response.response.status === 409) {
            toast.error(response.response.data.msg);
          }
        })
        .catch(() => {});
    },
  });

  const fields = [
    { name: "newpassword", label: "New Password", type: "password" },
    { name: "confirmpassword", label: "Confirm Password", type: "password" },
  ];

  return (
    <div className="lp-wrap">
      {/* ===== Page-scoped styles (white/pro look) ===== */}
      <style>{`
  :root{
    --bg:#f7f8fb;
    --ink:#0f172a;
    --muted:#64748b;
    --card:#ffffff;
    --border:#e5e7eb;
    --ring:#4f46e5;
    --brand:#4f46e5;
    --shadow: 0 10px 30px rgba(2,6,23,.06);
  }

  /* Page */
  .lp-wrap{
    min-height:100vh;
    padding:42px 20px;
    display:flex; align-items:center; justify-content:center;
    background: var(--bg);
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
    color:var(--ink);
  }

  /* Clean Card */
  .lp-card{
    width:100%; max-width:560px;
    border-radius:18px;
    background:var(--card);
    border:1px solid var(--border);
    box-shadow: var(--shadow);
    overflow:hidden;
  }

  /* Header */
  .lp-head{
    display:flex; align-items:center; gap:12px;
    padding:18px 22px;
    border-bottom:1px solid var(--border);
    background:#fff;
  }
  .lp-badge{
    height:38px; width:38px; border-radius:10px;
    display:grid; place-items:center;
    background:#eef2ff; color:var(--brand);
    border:1px solid #e0e7ff; font-weight:800;
  }
  .lp-title{ margin:0; font-size:20px; font-weight:800; color:#0b1220; }
  .lp-sub{ margin:2px 0 0; font-size:12px; color:var(--muted); }

 .auth-form button, .auth-form .btn, .auth-form [type="submit"] {
    margin-top: 16px;
    width: 100%;
    height: 46;
     border-radius: 10px !imporatnt;
    s: 999px;
    background: #2196F3 !important;
    color: #fff !important;
    font-weight: 800;
    border: 1px solid rgba(79,70,229,.2);
    box-shadow: 0 10px 24px rgba(79,70,229,.18);
    transition: transform .08s ease, box-shadow .2s ease, opacity .2s ease;
}
  .auth-form input[type="password"],
  .auth-form input[type="text"],
  .auth-form input[type="email"],
  .auth-form input[type="number"]{
    width:100%;
    background:#fff;
    border:1px solid var(--border);
    border-radius:12px;
    padding:12px 14px;
    color:var(--ink);
    outline:none;
    transition: border-color .16s ease, box-shadow .16s ease, transform .04s ease;
  }
  .auth-form input::placeholder{ color:#9aa3b2; }
  .auth-form input:focus{
    border-color: var(--ring);
    box-shadow: 0 0 0 3px rgba(79,70,229,.12);
    transform: translateY(-1px);
  }

  /* Submit button */
  .auth-form button, .auth-form .btn, .auth-form [type="submit"]{
    margin-top:16px;
    width:100%; height:46px; border-radius:999px;
    background: var(--brand);
    color:#fff; font-weight:800; letter-spacing:.2px;
    border:1px solid rgba(79,70,229,.2);
    box-shadow: 0 10px 24px rgba(79,70,229,.18);
    transition: transform .08s ease, box-shadow .2s ease, opacity .2s ease;
  }
  .auth-form button:hover{ opacity:.98; box-shadow: 0 14px 28px rgba(79,70,229,.24); }
  .auth-form button:active{ transform: translateY(1px); }

  /* Errors */
  .auth-form .invalid-feedback,
  .auth-form .text-danger,
  .auth-form .error{
    color:#e11d48 !important; font-size:12px; margin-top:6px;
  }

  /* Footer (toast holder) */
  .lp-foot{ padding:8px 22px 18px; display:flex; justify-content:center; background:#fff; }
`}</style>


      <div className="lp-card">
        {/* Header */}
        <div className="lp-head">
          <div className="lp-badge">🔒</div>
          <div>
            <h1 className="lp-title">Reset Password</h1>
            <p className="lp-sub">Set a strong password to keep your account secure</p>
          </div>
        </div>

        {/* Body */}
        <div className="lp-body">
          <div className="auth-form">
            <Formikform
              fieldtype={fields.filter((f) => !f.showWhen || f.showWhen(formik.values))}
              formik={formik}
              btn_name="Update Password"
              title="forUpdatePassword"
            />
          </div>
        </div>

        {/* Footer (kept) */}
        {/* <div className="lp-foot">
          <ToastButton />
        </div> */}
      </div>
    </div>
  );
};

export default UpdatePassword;
